<template>
  <div id="app">
    <header>
      <router-link to="/" tag="h6">Rhythm Reader</router-link>
      <router-link to="/app">Application</router-link>
      <router-link to="/">Introduction</router-link>
      <a href="https://rhythm-calculator.colour-field.jp">English version</a>
    </header>
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'Home',
  metaInfo: {
    title: 'Rhythm Reader（リズムリーダー）｜楽譜のリズムを音で聴ける無料Webリズムアプリ',
    meta: [
      { hid: 'description', name: 'description', content: 'Rhythm Reader（リズムリーダー）は、音符を入力するだけでリズムを自動再生できる無料リズム練習Webアプリです。楽譜のリズムがわからない初心者も、スマホやPCで簡単にリズム確認・メトロノーム練習が可能。インストール不要で今すぐ使えます。' }
    ]
  },
}
</script>
<style>
:root{
  --theme-color: #233b67;
}

#app {
  font-family: 'M PLUS Rounded 1c', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

#app > header{
  text-align: left;
  padding: 4px;
  margin: 0;
  background-color: var(--theme-color);
  font-family: 'Raleway', sans-serif;
}
#app > header > h6{
  display: inline-block;
  font-size: 1rem;
  margin: 4px 8px 4px 12px;
  color: #eee!important;
  text-decoration: none!important;
}
#app > header > a{
  font-size: 0.75rem;
  float: right;
  padding: calc(0.125rem + 4px) 1rem;
  color: #eee!important;
  text-decoration: none!important;
}

@media (min-width: 768px) {
  #app > header{
    padding: 4px 20%;
  }
}

#app > header > a.router-link-exact-active{
  display: none;
}
</style>
